<template>
  <div>
    <SOSlotModal :modal-title="`Simpan Pengaturan`" :modal-id="`modal${dataId}`" @close="back">
      <template v-slot:modal-body>
        <div class="md-content">
          <div>
            <p class="m-d-16">
              Aturan baru <span class="f-bold">berlaku untuk semua paket E-Payment di semua outlet</span> dan tidak akan
              mempengaruhi aturan E-Payment yang sedang dimiliki konsumen, sampai konsumen melakukan top up.
            </p>
            <p class="m-d-0">Yakin ingin menyimpan perubahan?</p>
          </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <SOButton
          :outline="true"
          :full="true"
          :text="'Ya, Simpan'"
          :id="dataId"
          :disable="isFetching"
          :loading="isFetching"
          @action="onApprove"
        />
      </template>
    </SOSlotModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../store/state";

export default {
  name: "SOConfirmSetEpayment",
  components: {
    SOSlotModal,
    SOButton,
  },
  data() {
    return {
      backLink: "pengaturanUmum.paket_epayment",
      idOutlet: "",
      epaymentRouteType: "",
      id: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setBackLink(from.name);
      if (from.query.idOutlet) {
        vm.setIdOutlet(from.query.idOutlet);
      }
    });
  },
  mounted() {
    if (this.backLink === "pengaturanUmum.penyesuaian") {
	  this.$router.push({ name: "pengaturanUmum.paket_epayment" });
	  return
    }
    this.idOutlet = this.$route.query.idOutlet
    this.epaymentRouteType = this.$route.query.epaymentRouteType
    this.id = this.$route.query.id
    $(`#modal${this.dataId}`).modal("show");
  },
  watch: {
    response(newRes, oldRes) {
      if (newRes.success) {
	    if (this.epayment.jenis_emoney === 2) this.$toast.success(newRes.msg)
      } else {
      	this.$toast.error(newRes.err);
      }

      if (newRes !== oldRes) {
        if (newRes.success === true) {
          if (this.epayment.jenis_emoney === 1) {
            this.$router.push({
              name: "pengaturanUmum.penyesuaian",
              query: { idOutlet: this.idOutlet, epaymentRouteType: this.epaymentRouteType, id: this.id },
            });
          } else {
            if (this.idOutlet) {
              this.$router.push(`/addOutlet/${this.idOutlet}/emoney/${this.epaymentRouteType}/${this.id}`);
            } else {
              if (this.backLink === "pengaturanUmum.paket_epayment" && this.idOutlet === undefined) {
                this.$router.push({name: "pengaturanUmum.dashboard"})
                return
              }
              this.$router.push({
                name: this.backLink,
              });
            }
          }
          this.closeModal();
        } else {
          this.$toast.error(newRes.err);
        }
      }
    },
  },
  computed: {
    ...mapGetters(moduleName, {
      response: "response",
      epayment: "epayment",
      isFetching: "fetching",
    }),
    dataId() {
      return "confirm-setting-e-payment";
    },
  },
  methods: {
    ...mapActions({
      updateSettingEpayment: `${moduleName}/updateSettingEpayment`,
    }),
    back() {
      this.closeModal();
      this.$router.push({ name: this.backLink, query: { idOutlet: this.idOutlet, epaymentRouteType: this.epaymentRouteType, id: this.id }});
    },
    closeModal() {
      $(`#modal${this.dataId}`).modal("hide");
    },
    setBackLink(routeBack) {
      this.backLink = routeBack;
    },
    setIdOutlet(isOutlet) {
      this.idOutlet = isOutlet;
    },
    onApprove() {
      this.updateSettingEpayment(this.epayment);
    },
  },
};
</script>
<style scoped>
.md-content {
  margin-bottom: -16px;
}
</style>
